export const environment = {
  production: true,
  current_environment_name: 'Production',
  server: 'lb3',
  is_whitelist_enabled: false,
  is_HTTPS_mandatory: true,
  ui: 'ec29dd332adf4037ab332ab61ee7df06',
  usr_pwd: 'd763odnd03lmsal',
  service_type: 'express',
  url: {
    service: 'https://bill-srvc.pnixsoft.com/',
    bulk_service: 'https://bill-srvc-bulk.pnixsoft.com/',
    bkp_service: 'https://bill-srvc-lb2.pnixsoft.com/',
    image: 'https://storage.googleapis.com/dev.img.lazybill.com/gal/',
    app: 'https://obill.pnixsoft.com/',
    app_without_www: 'https://obill.pnixsoft.com/',
    offlline_service: 'http://localhost:3012/',
    lbs_services: [
      'https://bill-srvc-lb1.pnixsoft.com/',
      'https://bill-srvc-lb2.pnixsoft.com/',
    ],
  },
};
